import { Col, Form } from "react-bootstrap";
import DateFilter from "../../../../../components/tools/DateFilter";

function DateRangePicker({
  startValue,
  endValue,
  setStart,
  setEnd,
  startError,
  endError,
  startLabel = "تاریخ شروع",
  endLabel = "تاریخ پایان",
  colProps = { xs: 12, md: 6 },
}) {
  return (
    <>
      <Col {...colProps}>
        <Form.Label>
          <span>{startLabel}</span>
          <span className="text-danger">*</span>
        </Form.Label>

        <DateFilter
          onChange={date => {
            setStart(date);
          }}
          label=""
          value={startValue}
        />
        {startError && (
          <p className="m-0 text-danger" style={{ fontSize: "14px" }}>
            {startError}
          </p>
        )}
      </Col>

      <Col {...colProps}>
        <Form.Label>
          <span>{endLabel}</span>
          <span className="text-danger">*</span>
        </Form.Label>

        <DateFilter
          onChange={date => {
            setEnd(date);
          }}
          label=""
          value={endValue}
        />
        {endError && (
          <p className="m-0 text-danger" style={{ fontSize: "14px" }}>
            {endError}
          </p>
        )}
      </Col>
    </>
  );
}

export default DateRangePicker;
